const style = {
  select: {
    padding: `5px 15px`,
    height: `40px`,
    overflow: `hidden`,
    background: `#fff`,
    border: `1px solid #ddd`,
    borderRadius: 0,
    '-webkit-appearance': `none`,
    fontSize: `14px`,
    width: `100%`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Statistics/style/selector.js